import { useContext, useEffect, useState } from "react";
import { FirebaseAuthContext } from "../../../commons/firebase/FirebaseAuthProvider";
import { firebaseService } from "../../../commons/firebase/Firebase";

// Hook for fetching the courses a player is registered to and the playlists of that course

const useRegisteredCourses = () => {
    // State storage of the courses shown in the table
    const [courses, setCourses] = useState([]);
    const [activeCourse, setActiveCourse] = useState(courses[0]);
    // Show loading before everything is initialized
    const [activeCoursePlaylists, setActiveCoursePlaylists] = useState([]);

    const [loadingCourses, setLoadingCourses] = useState(true);
    const [loadingPlaylist, setLoadingPlaylist] = useState(true);

    const { signedInUser } = useContext(FirebaseAuthContext);

    useEffect(() => {
        if (courses?.length > 0) {
            setActiveCourse(courses[0]);
        }
    }, [courses]);

    // Retrieving the courses and setting the list in the state variable
    const fetchCourses = async () => {
        try {
            const idToken = await signedInUser.getIdToken();
            const dataFromServer = await fetch(
                "/reg-main/users/courses/registered/" +
                signedInUser.uid +
                "?idToken=" +
                idToken
            );
            /*
                  Only set the user list in case the REST response was successful.
                  Otherwise (e.g. 401 - Unauthorized), logout the Firebase user.  
                   */
            if (dataFromServer.status === 200) {
                const coursesJson = await dataFromServer.json();
                setCourses(coursesJson);
                setLoadingCourses(false);
            } else {
                // This will lead to a re-direct to the main login page
                await firebaseService.auth().signOut();
            }
        } catch (err) {
            console.log(err);
        }
    };

    const fetchCoursePlaylists = async (course) => {
        try {
            const idToken = await signedInUser.getIdToken();
            const dataFromServer = await fetch(
                "/reg-main/courses/" +
                course.key +
                "/playlists/user/" +
                signedInUser.uid +
                "?idToken=" +
                idToken
            );
            /*
                  Only set the user list in case the REST response was successful.
                  Otherwise (e.g. 401 - Unauthorized), logout the Firebase user.  
                   */
            if (dataFromServer.status === 200) {
                const playlistsJson = await dataFromServer.json();
                setActiveCoursePlaylists(playlistsJson);
                console.log(playlistsJson);
                setLoadingPlaylist(false);
            } else {
                // This will lead to a re-direct to the main login page
                await firebaseService.auth().signOut();
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleChange = (event) => {
        console.log(event.target.value.key);
        setActiveCourse(event.target.value);
        setLoadingPlaylist(true);
    };

    const handleChangeClick = (course) => {
        setActiveCourse(course);
    };

    useEffect(() => {
        fetchCourses();
    }, []);

    useEffect(() => {
        if (activeCourse !== undefined) {
            fetchCoursePlaylists(activeCourse);
        }
    }, [activeCourse]);

    return {
        courses,
        activeCourse,
        activeCoursePlaylists,
        loadingCourses,
        loadingPlaylist,
        handleChange,
        handleChangeClick,
    };
};

export default useRegisteredCourses;
